import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue";
const _hoisted_1 = ["aria-label"];
const _hoisted_2 = ["aria-pressed", "onClick"];
import { useDonation } from "../../context/donationContext";
import { useChrome } from "../../i18n/useChrome";
export default /*@__PURE__*/ _defineComponent({
    __name: 'LanguageToggle',
    emits: ["locale-change"],
    setup(__props, { emit: __emit }) {
        // SYNC: see ../../_SYNC.md.
        const { availableLangs, lang, setLang } = useDonation();
        const { tf } = useChrome();
        const emit = __emit;
        function pick(code) {
            setLang(code);
            emit("locale-change", code);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: "df-lang",
                role: "group",
                "aria-label": _unref(tf)('lang.label')
            }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(availableLangs), (code) => {
                    return (_openBlock(), _createElementBlock("button", {
                        key: code,
                        type: "button",
                        class: _normalizeClass(["df-lang__btn", { 'is-active': _unref(lang) === code }]),
                        "aria-pressed": _unref(lang) === code,
                        onClick: ($event) => (pick(code))
                    }, _toDisplayString(code.toUpperCase()), 11 /* TEXT, CLASS, PROPS */, _hoisted_2));
                }), 128 /* KEYED_FRAGMENT */))
            ], 8 /* PROPS */, _hoisted_1));
        };
    }
});
